import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default (decodedToken) => new Promise((resolve) => {
  nsApi.getLogo({
    object: 'image',
    action: 'read',
    server: window.location.hostname,
    territory: decodedToken?.territory || '*',
    domain: decodedToken?.domain || '*',
    user: decodedToken?.user || '*',
    filename: 'video_main_top_left.png',
  }).then((res) => {
    if (res !== 'data:') {
      resolve(res);
    } else {
      nsApi.getLogo({
        object: 'image',
        action: 'read',
        server: window.location.hostname,
        territory: decodedToken?.territory || '*',
        domain: decodedToken?.domain || '*',
        user: decodedToken?.user || '*',
        filename: 'portal_main_top_left.png',
      }).then((logoRes) => {
        resolve(logoRes);
      }).catch(() => {
        resolve(false);
      });
    }
  }).catch(() => {
    nsApi.getLogo({
      object: 'image',
      action: 'read',
      server: window.location.hostname,
      territory: decodedToken?.territory || '*',
      domain: decodedToken?.domain || '*',
      user: decodedToken?.user || '*',
      filename: 'portal_main_top_left.png',
    }).then((res) => {
      resolve(res);
    }).catch(() => {
      resolve(false);
    });
  });
});
